export default __webpack_public_path__ + "static/media/download.6796197d.svg";